import TabsComponent, { ITabItems } from "./TabsComponent"
import { theme } from "../../../utils/theme/godzilla_light"
import { useMediaQuery } from "@mui/material";

interface IChildTabComponentProps {
    tabsList: ITabItems[];
    handleChange?: any;
    value: any;
}

const ChildTabsComponent = (props: IChildTabComponentProps) => {
    const { tabsList, handleChange, value } = props
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    return (
        <TabsComponent
            value={value}
            handleChange={handleChange}
            tabsList={tabsList}
            tabWrapperSx={{ backgroundColor: "#061A36", justifyContent: "space-between", flex: 1 }}
            tabItemSx={{ width: "300px" }}
            tabsSx={{
                flex: 1,
                '& .MuiTab-root': {
                    ...theme.typography.poppinsBodyRegular,
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: "1rem",
                    color: "#1E1E22",
                    backgroundColor: "#CDCBCA",
                    borderTopLeftRadius: "24px",
                    borderTopRightRadius: "24px",
                    display: "flex",
                    flex: isMobileX ? "none" : 1
                },
                '& .MuiTabs-indicator': {
                    backgroundColor: "#4B69F1",
                    gap: "16px"
                },
                '& .MuiTabs-list': {
                    backgroundColor: "#1E1E22",
                    gap: "16px"
                },
                '& .MuiTab-root.Mui-selected': {
                    ...theme.typography.poppinsBodyRegular,
                    backgroundColor: "#4B69F1",
                    color: "#fff",
                    fontSize: "1rem"
                }
            }}
        />
    )
}

export default ChildTabsComponent